const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.032,0,0,0.032,0,0)",
    stroke: "none",
    style: {
      fill: "#95a5a6"
    },
    d: "M 69 0 L 142 0 L 142 212 L 69 212 L 69 0 M 0 212 L 0 1000 L 69 1000 L 69 854 L 142 854 L 142 1000 L 212 1000 L 212 212 L 0 212 z M 142 784 L 69 784 L 69 712 L 142 712 L 142 784 z M 142 642 L 69 642 L 69 569 L 142 569 L 142 642 z M 142 500 L 69 500 L 69 427 L 142 427 L 142 500 z M 142 354 L 69 354 L 69 284 L 142 284 L 142 354 z M 284 142 L 284 1000 L 642 1000 L 642 142 L 284 142 z M 354 212 L 500 212 L 500 284 L 354 284 L 354 212 z M 354 500 L 427 500 L 427 569 L 354 569 L 354 500 z M 427 854 L 354 854 L 354 784 L 427 784 L 427 854 z M 569 854 L 500 854 L 500 784 L 569 784 L 569 854 z M 569 712 L 427 712 L 427 642 L 569 642 L 569 712 z M 569 427 L 500 427 L 500 354 L 569 354 L 569 427 z M 712 427 L 712 1000 L 1000 1000 L 1000 427 L 712 427 z M 854 854 L 784 854 L 784 784 L 854 784 L 854 854 z M 854 712 L 784 712 L 784 642 L 854 642 L 854 712 z M 927 569 L 784 569 L 784 500 L 927 500 L 927 569 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildIcon);
export default __webpack_public_path__ + "static/media/build-icon.a3c30a89b7143a955841010f88e82a4e.svg";
export { ForwardRef as ReactComponent };